module.exports = __webpack_public_path__ + "static/assets/afd7250deacdec3e3484381b942cc1f0.png";